
export default function Programs() {
  const schedules = [
    {
      sesi: "SESI 1",
      masa: "6.30 PAGI – 7.30 PAGI",
      kelas: "BACAAN AL QURAN"
    },
    {
      sesi: "SESI 2", 
      masa: "9.00 PAGI – 12.30 PETANG",
      kelas: "KELAS BERSAMA USTAZ",
      subkelas: ["KELAS TAHSIN", "KELAS TAHFIZ", "KELAS SYAHADAH", "KELAS KITAB"]
    },
    {
      sesi: "SESI 3",
      masa: "2.30 PETANG – 4.00 PETANG", 
      kelas: "KELAS MURAJA'AH"
    },
    {
      sesi: "SESI 4",
      masa: "7.30 PETANG – 8.45 PETANG",
      kelas: "BACAAN AL QURAN"
    },
    {
      sesi: "SESI 5", 
      masa: "10.00 MALAM – 10.45 MALAM",
      kelas: "KELAS MURAJA'AH"
    }
  ];

  const teachers = [
    {
      nama: "TAUFIK BIN KHAMIS @ MAHARAN",
      kelulusan: "PUSAT PENGAJIAN DARUL MUSTOFA LID DIRASTIL ISLAMIAH, HADRALMOUT YAMAN",
      jawatan: "MUDIR",
      telefon: "019 – 733 4434"
    },
    {
      nama: "MOHAMMAD AMMAR BIN YUNUS", 
      kelulusan: "PUSAT PENGAJIAN RIBAT TAREM LIT TADRISIL ULUM ADDINIYYAH WAL ARABIYAH HADRAMAUT YAMAN",
      jawatan: "GURU KITAB",
      telefon: "011 - 2059 4556"
    },
    {
      nama: "MUHAMMAD HANAFI BIN JAURI",
      kelulusan: "PONPES AL – QURAN MAGELANG INDONESIA, UTM SKUDAI",
      jawatan: "GURU KITAB", 
      telefon: "011 - 1532 4321"
    },
    {
      nama: "MUHAMAD FAIQ AZAHAR BIN ABDULLAH",
      kelulusan: "MADRASAH TAHFIZ AL QURAN AN – NUR, KESANG MUAR",
      jawatan: "GURU TAHFIZ",
      telefon: "011 - 3355 2970"
    },
    {
      nama: "MUHAMMAD SHOEF OMAR BIN YAHYA", 
      kelulusan: "MADRASAH TAHFIZ AL QURAN AN – NUR, KESANG MUAR",
      jawatan: "GURU TAHFIZ",
      telefon: "017 - 886 3359"
    },
    {
      nama: "MUHAMMAD FATHUL IMAN BIN MUHAMMAD AIDIL",
      kelulusan: "MADRASAH RIBAT THOHA",
      jawatan: "GURU TAHFIZ", 
      telefon: "011 - 6170 3861"
    },
    {
      nama: "MUHAMMAD SHARYFUL HAFIZIN BIN ISHAK",
      kelulusan: "MADRASAH TAHFIZ AL QURAN ZAWIYAH DARUL MADAD",
      jawatan: "GURU TAHFIZ",
      telefon: "011 - 2119 1606"
    },
    {
      nama: "MUHAMMAD ZULHANAFIAH BIN ZULKEFFLEE",
      kelulusan: "OPEN UNIVERSITY MALAYSIA",
      jawatan: "GURU TAHSIN", 
      telefon: "017 - 799 4105"
    },
    {
      nama: "AHMAD MUZZAMMIL BIN ROSLI",
      kelulusan: "MADRASATUL QURAN KUBANG BUJUK, KUALA TERENGGANU",
      jawatan: "GURU SYAHADAH",
      telefon: "011 - 3773 2841"
    }
  ];

  return (
    <section id="program" className="py-20 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Program Pendidikan</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Program pembelajaran yang komprehensif untuk membentuk generasi Qurani yang cemerlang
          </p>
        </div>

        {/* Jadual Pembelajaran */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-emerald-900 mb-8 text-center">Sesi Pembelajaran di Madrasah</h3>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {schedules.map((schedule, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-emerald-100">
                <div className="text-center mb-4">
                  <h4 className="text-xl font-bold text-emerald-900 mb-2">{schedule.sesi}</h4>
                  <div className="bg-emerald-100 rounded-lg p-3 mb-3">
                    <p className="text-emerald-800 font-semibold">{schedule.masa}</p>
                  </div>
                </div>
                <div className="text-center">
                  <p className="text-gray-700 font-medium mb-2">{schedule.kelas}</p>
                  {schedule.subkelas && (
                    <div className="space-y-1">
                      {schedule.subkelas.map((sub, idx) => (
                        <div key={idx} className="text-sm text-emerald-600 bg-emerald-50 rounded px-3 py-1">
                          {sub}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Maklumat Guru */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-emerald-900 mb-8 text-center">Maklumat Guru-Guru</h3>
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-emerald-900 text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-bold">BIL</th>
                    <th className="px-6 py-4 text-left font-bold">NAMA GURU</th>
                    <th className="px-6 py-4 text-left font-bold">KELULUSAN</th>
                    <th className="px-6 py-4 text-left font-bold">JAWATAN</th>
                    <th className="px-6 py-4 text-left font-bold">NO. TELEFON</th>
                  </tr>
                </thead>
                <tbody>
                  {teachers.map((teacher, index) => (
                    <tr key={index} className={`border-b border-gray-200 hover:bg-emerald-50 transition-colors ${index === 0 ? 'bg-yellow-50' : ''}`}>
                      <td className="px-6 py-4 font-semibold text-emerald-900">{index + 1}.</td>
                      <td className="px-6 py-4">
                        <div className="font-bold text-emerald-900">{teacher.nama}</div>
                      </td>
                      <td className="px-6 py-4 text-gray-700 text-sm">{teacher.kelulusan}</td>
                      <td className="px-6 py-4">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                          teacher.jawatan === 'MUDIR' 
                            ? 'bg-yellow-100 text-yellow-800' 
                            : 'bg-emerald-100 text-emerald-800'
                        }`}>
                          {teacher.jawatan}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-gray-700 font-mono">{teacher.telefon}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Program Kelas */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-emerald-500">
            <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mb-6">
              <i className="ri-book-open-line text-2xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-bold text-emerald-900 mb-4">Kelas Tahsin</h3>
            <p className="text-gray-600 mb-4">Pembelajaran asas bacaan Al-Quran dengan tajwid yang betul</p>
            <div className="text-2xl font-bold text-emerald-600">11 Pelajar</div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-yellow-500">
            <div className="w-16 h-16 flex items-center justify-center bg-yellow-100 rounded-full mb-6">
              <i className="ri-heart-line text-2xl text-yellow-600"></i>
            </div>
            <h3 className="text-xl font-bold text-emerald-900 mb-4">Kelas Tahfiz</h3>
            <p className="text-gray-600 mb-4">Program hafazan Al-Quran dengan kaedah yang berkesan</p>
            <div className="text-2xl font-bold text-yellow-600">38 Pelajar</div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-500">
            <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mb-6">
              <i className="ri-award-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-bold text-emerald-900 mb-4">Kelas Syahadah</h3>
            <p className="text-gray-600 mb-4">Program sijil dan pengiktirafan dalam pengajian Islam</p>
            <div className="text-2xl font-bold text-blue-600">10 Pelajar</div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-purple-500">
            <div className="w-16 h-16 flex items-center justify-center bg-purple-100 rounded-full mb-6">
              <i className="ri-book-2-line text-2xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-bold text-emerald-900 mb-4">Kelas Kitab</h3>
            <p className="text-gray-600 mb-4">Pembelajaran kitab-kitab turath dan ilmu agama</p>
            <div className="text-2xl font-bold text-purple-600">12 Pelajar</div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <div className="bg-emerald-900 rounded-2xl p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">Sertai Kami Hari Ini</h3>
            <p className="text-xl text-emerald-100 mb-8 max-w-2xl mx-auto">
              Berikan anak anda pendidikan Islam yang terbaik dengan program tahfiz dan pengajian yang komprehensif
            </p>
            <a 
              href="#kontak" 
              className="inline-flex items-center gap-2 bg-yellow-500 text-emerald-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line"></i>
              Hubungi Kami Sekarang
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}